// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Container principal */
.auth-container {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
}

/* Caixa principal reutilizável */
.auth-card {
  display: flex;
  width: 700px;
  background: white;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);
  border-radius: 10px;
  overflow: hidden;
  transition: transform 0.6s ease-in-out;
}

/* Lado esquerdo com imagem */
.auth-left {
  width: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.auth-left img {
  max-width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Lado direito com formulário */
.auth-right {
  width: 50%;
  padding: 30px;
  text-align: center;
}

.auth-right h1 {
  font-size: 22px;
  margin-bottom: 20px;
  color: #333;
}

/* Formulários */
.auth-form {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 90%;
}

.auth-label {
  font-size: 14px;
  text-align: left;
  color: #333;
  font-weight: bold;
}

/* Inputs */
.auth-input {
  width: 100%;
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

/* Botões */
/* From Uiverse.io by adamgiebl */ 
.auth-submit-button {
  color: #090909;
  padding: 0.7em 1.7em;
  font-size: 18px;
  border-radius: 0.5em;
  background: #e8e8e8;
  cursor: pointer;
  border: 1px solid #e8e8e8;
  transition: all 0.3s;
  box-shadow: 6px 6px 12px #c5c5c5, -6px -6px 12px #ffffff;
}

.auth-submit-button:hover {
  border: 1px solid white;
}

.auth-submit-button:active {
  box-shadow: 4px 4px 12px #c5c5c5, -4px -4px 12px #ffffff;
}


/* Link para alternar entre login e registro */
.auth-toggle-text {
  margin-top: 15px;
  font-size: 14px;
  color: #007bff;
  cursor: pointer;
}

.auth-toggle-text span {
  text-decoration: underline;
}

.auth-toggle-text:hover span {
  text-decoration: none;
}

/* Responsivo */
@media (max-width: 768px) {
  .auth-card {
    flex-direction: column;
    width: 90%;
  }

  .auth-left {
    width: 100%;
  }

  .auth-form {
    width: 80%;
  }

  .auth-right {
    width: 95%;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding-left: 0;
  }
}
`, "",{"version":3,"sources":["webpack://./src/styles/Login.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,YAAY;EACZ,iBAAiB;EACjB,0CAA0C;EAC1C,mBAAmB;EACnB,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA,6BAA6B;AAC7B;EACE,UAAU;EACV,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,iBAAiB;AACnB;;AAEA,gCAAgC;AAChC;EACE,UAAU;EACV,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,UAAU;AACZ;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,iBAAiB;AACnB;;AAEA,WAAW;AACX;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA,WAAW;AACX,iCAAiC;AACjC;EACE,cAAc;EACd,oBAAoB;EACpB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,eAAe;EACf,yBAAyB;EACzB,oBAAoB;EACpB,wDAAwD;AAC1D;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,wDAAwD;AAC1D;;;AAGA,8CAA8C;AAC9C;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA,eAAe;AACf;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;IACV,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,eAAe;EACjB;AACF","sourcesContent":["/* Container principal */\n.auth-container {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 100vh;\n}\n\n/* Caixa principal reutilizável */\n.auth-card {\n  display: flex;\n  width: 700px;\n  background: white;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.2);\n  border-radius: 10px;\n  overflow: hidden;\n  transition: transform 0.6s ease-in-out;\n}\n\n/* Lado esquerdo com imagem */\n.auth-left {\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.auth-left img {\n  max-width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Lado direito com formulário */\n.auth-right {\n  width: 50%;\n  padding: 30px;\n  text-align: center;\n}\n\n.auth-right h1 {\n  font-size: 22px;\n  margin-bottom: 20px;\n  color: #333;\n}\n\n/* Formulários */\n.auth-form {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 90%;\n}\n\n.auth-label {\n  font-size: 14px;\n  text-align: left;\n  color: #333;\n  font-weight: bold;\n}\n\n/* Inputs */\n.auth-input {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  font-size: 16px;\n}\n\n/* Botões */\n/* From Uiverse.io by adamgiebl */ \n.auth-submit-button {\n  color: #090909;\n  padding: 0.7em 1.7em;\n  font-size: 18px;\n  border-radius: 0.5em;\n  background: #e8e8e8;\n  cursor: pointer;\n  border: 1px solid #e8e8e8;\n  transition: all 0.3s;\n  box-shadow: 6px 6px 12px #c5c5c5, -6px -6px 12px #ffffff;\n}\n\n.auth-submit-button:hover {\n  border: 1px solid white;\n}\n\n.auth-submit-button:active {\n  box-shadow: 4px 4px 12px #c5c5c5, -4px -4px 12px #ffffff;\n}\n\n\n/* Link para alternar entre login e registro */\n.auth-toggle-text {\n  margin-top: 15px;\n  font-size: 14px;\n  color: #007bff;\n  cursor: pointer;\n}\n\n.auth-toggle-text span {\n  text-decoration: underline;\n}\n\n.auth-toggle-text:hover span {\n  text-decoration: none;\n}\n\n/* Responsivo */\n@media (max-width: 768px) {\n  .auth-card {\n    flex-direction: column;\n    width: 90%;\n  }\n\n  .auth-left {\n    width: 100%;\n  }\n\n  .auth-form {\n    width: 80%;\n  }\n\n  .auth-right {\n    width: 95%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    padding-left: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
